import styled from 'styled-components';
import { ReactComponent as Close } from 'Images/clear.svg';

export const CloseIcon = styled(Close)`
  margin-left: 6px;
  cursor: pointer;
  ${({ isOneOfVal }) => isOneOfVal && `
    position: absolute;
    right: 10px;
    top: 11px;
  `}
  & > g > g {
    stroke: ${({ theme }) => theme.text.attributeTag};
  }
  `;
CloseIcon.displayName = 'CloseIcon';

const opShadow = 'inset 0 0 12px 0 rgba(144, 169, 192, 0.16)';
const normalShadow = '0 0 5px 0 rgba(0, 0, 0, 0.06)';

export const FilterTagContainer = styled.div`
  display:flex;
  flex-direction: row;
`;

export const TagContainer = styled.div`
  cursor: default;
  display:flex;
  flex-direction: row;
  align-items: center;
  height: ${({ isOneOf }) => (isOneOf ? 'auto' : '24px')};
  padding: 6px 7px 5.5px 7px;
  margin-right:     ${({ type }) => (type === 'val' && '5px')};
  background-color: ${({ type, theme }) => (type === 'op' ? theme.backgrounds.attributeTagOp : theme.backgrounds.attributeTag)};
  box-shadow:       ${({ type }) => (type === 'op' ? opShadow : normalShadow)};
  border-top:       ${({ type, theme }) => (type === 'op' && `solid 1px ${theme.borders.attributeTag}`)};
  border-bottom:    ${({ type, theme }) => (type === 'op' && `solid 1px ${theme.borders.attributeTag}`)};
  border-right:     ${({ valSelected, theme }) => (!valSelected && `solid 1px ${theme.borders.attributeTag}`)};
  border:           ${({ type, theme }) => (type !== 'op' && `solid 1px ${theme.borders.attributeTag}`)};
  border-radius:    ${({ type }) => {
    if (type === 'key') return '2px 0px 0px 2px';
    if (type === 'val') return '0px 2px 2px 0px';
    return '0px';
  }};
  ${({ isOneOf, type, theme }) => (isOneOf && (type === 'val')) && `
    background-color: ${theme.backgrounds.attributeIsOneOfVal};
    padding: 6px 24px 2px 2px;
    flex-wrap: wrap;
    position: relative;
  `}
`;

export const TagLabel = styled.div`
  text-align: left;
  font-size: 11.5px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${({ type, theme }) => (type === 'op' ? theme.text.attributeOpTag : theme.text.attributeTag)};
  white-space: nowrap;
`;

export const Label = styled(TagLabel)`
  background-color: #fff;
  padding: 1px 5px;
  margin: 0 2px;
  border-radius: 2px;
  margin-bottom: 4px;
`;
Label.displayName = 'Label';
